export const SUCCESS = '0000'
